import { Fragment } from 'react';
import { TabPane } from 'reactstrap';
import { H3, H5, Image, LI, P, UL } from '../../../../AbstractElements';
import { EmailAddress, Gender, General, Href, Personal, Print } from '../../../../Constant';
import { ORGANIZATION_DATA } from '../../../../Data/Contacts';
import { dynamicImage } from '../../../../Service/DynamicImage';

const TabOrg = () => {
  
  return (
    <Fragment>
      {ORGANIZATION_DATA.map((item, i) =>
        <TabPane tabId={item.activeTab} key={i}>
          <div className="profile-mail">
          <div className="d-flex">
              <Image className= 'p-0 img-100 img-fluid m-r-20 rounded-circle update_img_5' src= {dynamicImage(`${item.image}`)} alt= 'images'  />
              <div className="flex-grow-1">
                <H5><span className="first_name_5">{item.name}</span></H5>
                <P className='email_add_5' >{item.email}</P>
                <UL className='simple-list'>
                  <LI><a href={Href}>{Print}</a></LI>
                </UL>
              </div>
            </div>
            <div className="email-general">
              <H3>{General}</H3>
              <P>{EmailAddress}: <span className="font-primary email_add_5">{item.email}</span></P>
              <div className="gender">
                <H3>{Personal}</H3>
                <P>{Gender}: <span>{item.gender}</span></P>
              </div>
            </div>
          </div>
        </TabPane>
      )}
    </Fragment>
  );
};

export default TabOrg;